import { Path } from "@router/paths";

export const TAB_INDEX_TO_ROUTES_LIST = [
	Path.profileMenu.account.accountData.path,
	Path.profileMenu.account.members.path,
	Path.profileMenu.account.groups.path,
	Path.profileMenu.account.learntracking.path,
];
